
import { Component, Vue } from "vue-property-decorator";
import { namespace } from "vuex-class";
import TextTips from "@common/src/components/scope/text-tips/index.vue";
import t from "@common/src/i18n/t";

const setting = namespace("setting");
const app = namespace("app");
@Component({
  components: { TextTips }
})
export default class Template extends Vue {
  @setting.Action queryDocumentNumberSettingList;
  @setting.Action saveDocumentNumberSetting;
  @app.Mutation setPBPX;
  created() {
    this.setPBPX(52);
    this.init();
  }
  settingList: any = [];
  init() {
    this.queryDocumentNumberSettingList().then(data => {
      this.settingList = data.data?.list;
    });
  }
  handleSave() {
    if (this.settingList.some(item => item.prefix.length > 5)) {
      return this.$message.error(t("v216_g.there-is-data-with-a-prefix-modify-it"));
    }
    this.saveDocumentNumberSetting({ list: this.settingList }).then(() => {
      this.$message.success(t("base.save-success"));
      this.init();
    });
  }
}
